export default __webpack_public_path__ + "static/media/slide-3.7a49495d.png";